import { sanitizeText } from "./sanitizeText.js";
export const ensurePhoneExternalReference = (references, phone) => {
    if (!phone)
        return references || [];
    const hasPhone = references?.some((ref) => ref.key === "phone") ?? false;
    return hasPhone
        ? (references ?? [])
        : [...(references ?? []), { key: "phone", value: sanitizeText(phone) }];
};
